module.exports = __webpack_public_path__ + "img/newsImg11-15.69f80585.png";